// extracted by mini-css-extract-plugin
export default {"quick":"Shoe_quick__-BTxi","image":"Shoe_image__OTSjJ","flex":"Shoe_flex__izx1u","h":"Shoe_h__BEYoM"};